import { createFileRoute } from '@tanstack/react-router';

import NegotiationDemandGroupOverviewPage from '@/areas/negotiations/Negotiations/NegotiationDemandGroupOverviewPage/NegotiationDemandGroupOverviewPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <NegotiationDemandGroupOverviewPage {...pathParams} />;
}
